module.exports = __webpack_public_path__ + "static/media/power-50.ad9eecd0.svg";